import { Component, CUSTOM_ELEMENTS_SCHEMA,  } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { Router } from '@angular/router';
import { MenuStateService } from '../../services/menu.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-side-menu',
    templateUrl: './side-menu.component.html',
    styleUrls: ['./side-menu.component.scss'],
    imports: [ 
      TegelModule, CommonModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SideMenuComponent {

  menuItems = [
    { key: 1, label: 'Home', icon: 'home', path: 'home' },
    { key: 2, label: 'SPCT', icon: 'dashboard', path: 'spct' },
    { key: 3, label: 'General', icon: 'send', path: 'general' },
    { key: 4, label: 'Activity List', icon: 'list', path: 'activity-list'},
    { key: 5, label: 'Summary', icon: 'layer', path: 'summary'},
    { key: 6, label: 'Settings', icon: 'settings', path: 'settings' },
  ];

  isMenuOpened = false;

  constructor (private router: Router, private menuStateService: MenuStateService){
    this.menuStateService.signal$.subscribe((value) => {
      this.mobileMenuAction(value);
    });
  }
  
  selectedMenu$ = this.menuStateService.selectedMenu$;

  navigate(menuKey: string, path: string) {
    this.isMenuOpened = false;
    this.menuStateService.setSelectedMenu(menuKey);
    this.router.navigateByUrl(path);
  }

  selectMenu(menuKey: string) {
    this.menuStateService.setSelectedMenu(menuKey);
  }

  mobileMenuAction(action: boolean) {
    this.isMenuOpened = action;
  }
}
